import React, { createContext, useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import apiClient from "./apiClient";
import AuthContext from "./auth-context";

const AutoLogoutContext = createContext();

export const AutoLogoutProvider = ({ children }) => {
    const { dispatch, state } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation(); // Add this to track route changes

    const getToken = () => {
        return (
            localStorage.getItem("jwtToken") ||
            localStorage.getItem("authToken") ||
            localStorage.getItem("token")
        );
    };

    const isJWTExpired = (token) => {
        if (!token) return true;

        try {
            const decoded = jwtDecode(token);
            const currentTime = Date.now() / 1000;
            return decoded.exp < currentTime;
        } catch (error) {
            console.error("Error decoding JWT:", error);
            return true;
        }
    };

    const logout = async () => {
        console.log("JWT expired - logging out user");
        try {
            await apiClient.post("/api/Account/logout");
        } catch (error) {
            console.error("Logout API call failed", error);
        }

        localStorage.removeItem("jwtToken");
        localStorage.removeItem("authToken");
        localStorage.removeItem("token");

        dispatch({ type: "LOGOUT" });
        navigate("/login", {
            state: { returnTo: location.pathname + location.search },
        });
    };

    const checkJWTExpiration = () => {
        if (!state.isAuthenticated) return;

        const token = getToken();
        if (isJWTExpired(token)) {
            logout();
        }
    };

    useEffect(() => {
        // Check JWT expiration on route changes and auth state changes
        if (state.isAuthenticated) {
            checkJWTExpiration();
        }
    }, [state.isAuthenticated, location.pathname]); // Add location.pathname dependency

    return <AutoLogoutContext.Provider value={{ checkJWTExpiration }}>{children}</AutoLogoutContext.Provider>;
};

export const useAutoLogout = () => {
    return useContext(AutoLogoutContext);
};
